export const api = {
  sts: 'https://api-staging.playhunch.net/',
  dev: 'https://api-develop.playhunch.net/',
  prod: 'https://api.playhunch.io/',
  local: 'http://localhost:8081/'
};
